var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalled = function SvgCalled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.546 5.5 19.09 11h4.09c0 4.558-3.66 8.25-8.181 8.25-1.384 0-2.68-.35-3.825-.956l-1.99 2.008A10.862 10.862 0 0 0 15 22c6.027 0 10.91-4.922 10.91-11H30l-5.454-5.5zM6.817 11c0-4.558 3.662-8.25 8.182-8.25 1.384 0 2.68.35 3.825.956l1.99-2.008A10.862 10.862 0 0 0 15 0C8.973 0 4.09 4.923 4.09 11H0l5.455 5.5 5.454-5.5H6.82z"
  })));
};
export default SvgCalled;